import { createContext } from 'react';
import { FormInput } from './FormInputs';
import { FormFieldSetStatus, FormFieldStatus } from './FormFieldStatus';
import { InputStatus } from '../inputs/InputStatus';

export type FormField = {
  status: FormFieldStatus;
  setStatus: FormFieldSetStatus;
};

export type FormFieldInput = {
  input: FormInput;
  setDefault: (message?: string) => void;
  setError: (message?: string) => void;
  setState: (state: { message?: string; status: InputStatus }) => void;
  setSuccess: (message?: string) => void;
  setWarning: (message?: string) => void;
};

export type ContextValue = {
  inputs: Map<string, FormInput[]>;
  fields: Map<string, FormField>;
  setField: (name: string, value: FormFieldInput) => void;
};

export const FormContext = createContext<ContextValue>({
  inputs: new Map(),
  fields: new Map(),
  setField: () => undefined,
});
